import React from 'react';
import { Divider } from '@mui/material';
import PropTypes from 'prop-types';

// Define the default style for consistency
const defaultDividerStyle = {
    borderColor: '#333', 
    borderBottomWidth: '1px', 
    width: '100%', 
    marginTop: '20px',
    marginBottom: '20px',
};

function DividerComponent({ sx }) {
    const combinedSx = { ...defaultDividerStyle, ...sx };

    return <Divider sx={combinedSx} />;
}

DividerComponent.propTypes = {

  sx: PropTypes.object,
};

DividerComponent.defaultProps = {
  sx: {},
};

export default DividerComponent;
